import makeRequest, {HttpMethod} from "./request";
import {removeCsrfToken, removeToken, removeTokenTmp} from "../Storages/cookies";
import {authData, listAdminModulesActions} from "../Storages";

const logout = makeRequest('logout').prepare(async (params: object) => {
    const {data, response, method} = params as { data: any; response: any, method: HttpMethod };

    if (response?.ok) {
        removeTokenTmp();
        removeToken();
        removeCsrfToken();
        authData.remove();
        listAdminModulesActions.remove();
        window.location.href = '/login';
    }

    return {
        data,
        response,
        method
    };
});

export default logout;